import React from "react";
import { MCStateContext } from "..";
import PropTypes from "prop-types";
import { TooltipHover } from "./TooltipHover";
import { TooltipNormal } from "./TooltipNormal";
import { InteractionArea } from "./InteractionArea";
import {
  checkRotorPresent,
  checkSolutionPresent,
  getFilledSlotCount,
} from "./Tooltips.utils";

import "./style.scss";

export function Tooltips(props) {
  const { isLidOpen } = React.useContext(MCStateContext);

  const className = !isLidOpen ? `mc_tooltip_lidClosed` : `mc_tooltip_lidOpen`;

  return (
    <>
      {!props.hover && (
        <TooltipNormal
          className={className}
          slotsFilled={getFilledSlotCount(props.slots)}
          setHover={props.setHover}
        />
      )}
      {props.hover && (
        <TooltipHover
          className={className}
          setModalView={props.setModalView}
          toggleLid={props.toggleLid}
          slots={props.slots}
          openModal={props.openModal}
          solutionPresent={checkSolutionPresent(props.slots)}
          rotorPresent={checkRotorPresent(props.slots)}
          removeSlotItems={props.removeSlotItems}
          setHover={props.setHover}
        />
      )}
      <InteractionArea setHover={props.setHover} />
    </>
  );
}

Tooltips.propTypes = {
  /**
   * specifies if microcentrifuge is in state hover or not
   */
  hover: PropTypes.bool,
  /**
   * gives the arrangement of slots in centrifuge
   */
  slots: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * unique id of each slots
       */
      id: PropTypes.number,
      /**
       * specifies of rotor present in slot
       */
      rotor: PropTypes.bool,
      /**
       * specifies of solution(tube) present in slot
       */
      solution: PropTypes.bool,
    })
  ),

  ...TooltipHover.propTypes,
};
